export const colors = {
  colorPrimary: "rgb(103, 58, 183)",
};
